import { useState } from "react"
import { Box, Flex, Text, Icon, Field, Textarea } from "@chakra-ui/react"
import { FaEdit } from "react-icons/fa"
import useStore from "../../../store"
import useDisclosure from "../../../hooks/useDisclosure"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"
import Spinner from "../../common/Spinner"
import { colors } from "../../../utilities/colors"

export default function DealerStatusInfoItem({ dealer }) {
  const { suspendDealer, unSuspendDealer, dealerFetching } = useStore()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [statusNotes, setStatusNotes] = useState("")

  const currentStatus = dealer.attributes["active-status"]
  const isActive = currentStatus === "Active"
  const drawerTitle = isActive ? "Suspend Dealer" : "Make Dealer Active"
  const confirmationText = `You are about to ${isActive ? "suspend" : "unsuspend"} ${dealer.attributes["name"]}`

  const statusColor = (status) => {
    if (status === "Collection") {
      return colors.fpxRed
    } else if (status === "Suspended") {
      return colors.yellow
    } else {
      return colors.grey100
    }
  }

  const handleEditStatus = () => {
    setStatusNotes("")
    onOpen()
  }

  const handleConfirmSave = () => {
    const notes = statusNotes.trim() || null

    if (isActive) {
      suspendDealer(dealer.id, notes)
    } else {
      unSuspendDealer(dealer.id, notes)
    }

    onClose()
  }

  const handleCancelSave = () => {
    onClose()
  }

  return (
    <Box p={1}>
      <Text fontSize="sm" color={colors.grey300}>Status</Text>
      <Flex align="center" minH="1.5rem">
        {dealerFetching ? (
          <Spinner color="grey-300" height="20px" width="20px" strokeWidth={6} />
        ) : (
          <>
            <Text fontSize="md" color={statusColor(currentStatus)}>{currentStatus}</Text>
            <Icon
              ml={2}
              color={colors.grey300}
              cursor="pointer"
              onClick={handleEditStatus}
              data-testid="edit-icon"
            >
              <FaEdit />
            </Icon>
          </>
        )}
      </Flex>
      <ActionConfirmDrawer
        title={drawerTitle}
        size="sm"
        renderTrigger={false}
        bgColor={colors.black}
        bodyStyle="flex flex-col w-full px-4 gap-4"
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleConfirmSave}
        onCancel={handleCancelSave}
        body={
          <>
            <Text fontSize="sm" color={colors.fpxRed}>{confirmationText}</Text>
            <Field.Root id="status-notes">
              <Field.Label fontSize="sm" color={colors.grey300} htmlFor="status-notes">Notes</Field.Label>
              <Textarea
                id="status-notes"
                placeholder="Add notes"
                value={statusNotes}
                onChange={(event) => setStatusNotes(event.target.value)}
                bgColor={colors.grey900}
                borderRadius="md"
                _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
              />
            </Field.Root>
          </>
        }
      />
    </Box>
  )
}
